import { useSettings } from "../context/SettingsContext";

function linkFor(value) {
  if (!value) return null;
  const v = value.trim();
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return `mailto:${v}`;
  if (/^\+?\d[\d\s().-]{5,}$/.test(v)) return `tel:${v.replace(/\s+/g, "")}`;
  if (/^(https?:)?\/\//i.test(v)) return v;
  return null;
}

export default function Footer() {
  const { settings } = useSettings();
  const items = (settings.footer_items || []).filter((i) => i.enabled !== false);
  const wordmark = settings.wordmark || "tramæ";
  return (
    <footer
      data-testid="site-footer"
      className="tr-dark border-t border-white/10 px-6 sm:px-12 py-10"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <p data-testid="footer-wordmark" className="font-display text-2xl tracking-[0.32em] lowercase">
          {wordmark}
        </p>
        <div className="flex flex-wrap items-center gap-6 text-[0.7rem] uppercase tracking-[0.24em] font-sub text-[rgba(248,247,244,0.6)]">
          <span data-testid="footer-copy">© {new Date().getFullYear()} {wordmark} Studio</span>
          {items.map((it) => {
            const href = linkFor(it.value);
            const content = it.value;
            return href ? (
              <a
                key={it.id}
                href={href}
                className="hover:text-[color:var(--tr-accent)] transition-colors"
                data-testid={`footer-item-${it.id}`}
              >
                {content}
              </a>
            ) : (
              <span key={it.id} data-testid={`footer-item-${it.id}`}>
                {content}
              </span>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
